import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PhotosRoutesViewerPage } from './photos-routes-viewer';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    PhotosRoutesViewerPage
  ],
  imports: [
    IonicPageModule.forChild(PhotosRoutesViewerPage),
    ComponentsModule
  ],
})
export class PhotosRoutesViewerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/photos-routes-viewer/photos-routes-viewer.module.ts